import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

import Pill from '../Pill';
import { useStyles } from './planSummaryHeader.styles';

function PlanSummaryHeader (props) {
    const {
        microLabel,
        planName,
        showActiveBadge,
        showCancellationPendingBadge,
        tierLabel,
        price,
        currencySymbol,
    } = props;

    const classes = useStyles();

    return (
        <div className={classes.headerRow}>
            <div>
                <Typography className={classes.microLabel}>
                    {microLabel}
                </Typography>
                <div className={classes.planNameRow}>
                    <span className={classes.planName}>{planName}</span>
                    {showCancellationPendingBadge ? (
                        <Pill label="CANCELLATION PENDING" tone="cancellationPending" dot />
                    ) : showActiveBadge && (
                        <Pill label="ACTIVE" tone="active" dot />
                    )}
                    {tierLabel && (
                        <Pill label={tierLabel} tone="tier" />
                    )}
                </div>
            </div>
            {price != null && (
                <div className={classes.priceBox}>
                    <span className={classes.price}>
                        {`${currencySymbol}${Number(price).toLocaleString()}`}
                    </span>
                    <span className={classes.priceUnit}>/mo</span>
                </div>
            )}
        </div>
    );
}

PlanSummaryHeader.propTypes = {
    microLabel: PropTypes.string,
    planName: PropTypes.string,
    showActiveBadge: PropTypes.bool,
    showCancellationPendingBadge: PropTypes.bool,
    tierLabel: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currencySymbol: PropTypes.string,
};

PlanSummaryHeader.defaultProps = {
    microLabel: '',
    planName: '',
    showActiveBadge: false,
    showCancellationPendingBadge: false,
    tierLabel: '',
    price: null,
    currencySymbol: '',
};

export default PlanSummaryHeader;
